<template>
  <el-dialog
    :title="modalTitle"
    :visible="visible"
    width="950px"
    center
    :close-on-click-modal="true"
    @close="close()"
    class="custom-dialog"
  >
    <el-card shadow="always">
      <el-form :model="siloTrxToEdit" ref="formSilo">
        <!-- PRODUCT -->
        <div class="gridTemplate-five" style="margin-top: 0px !important">
          <p class="dialog-p-subtitle">{{ i18nValues['product'] }}</p>
          <!-- Crop Type -->
          <el-form-item :label="i18nValues['crop']" prop="crop">
            <el-input v-model="siloTrxToEdit.cropType" disabled></el-input>
          </el-form-item>
          <!-- Brand -->
          <el-form-item label="Brand" prop="brand">
            <el-input v-model="siloTrxToEdit.product.brand" disabled></el-input>
          </el-form-item>
          <!-- Variety -->
          <el-form-item :label="i18nValues['variety']" prop="variety">
            <el-input v-model="siloTrxToEdit.product.name" disabled></el-input>
          </el-form-item>
        </div>

        <div></div>

        <!-- FIELD -->
        <div class="gridTemplate-five" style="margin-top: 2px; margin-bottom: 2px">
          <p class="dialog-p-subtitle">{{ i18nValues['location'] }}</p>
          <!-- Field -->
          <el-form-item :label="i18nValues['field']" prop="field">
            <el-input v-model="siloTrxToEdit.field.name" disabled></el-input>
          </el-form-item>
          <!-- FieldLot -->
          <el-form-item :label="i18nValues['batch']" prop="fieldLot">
            <el-input :value="siloTrxToEdit.fieldLot ? siloTrxToEdit.fieldLot.name : ''" disabled></el-input>
          </el-form-item>
        </div>

        <div></div>

        <!-- TRANSPORT -->
        <div class="gridTemplate-five" style="margin-top: 2px; margin-bottom: 2px">
          <p class="dialog-p-subtitle">{{ i18nValues['transport'] }}</p>
          <!-- Date -->
          <el-form-item :label="i18nValues['date']" prop="transportDate">
            <div class="input-group">
              <el-date-picker 
                type="date"
                class="calendar"
                format="dd/MM/yyyy"
                disabled
                v-model="siloTrxToEdit.transportDate"
                placeholder="Select date"
              ></el-date-picker>
              <span class="input-group-addon primary el-input__suffix icon">
                <span class="arrow"></span>
                <i class="fa fa-calendar-alt"></i>
              </span>
            </div>
          </el-form-item>
          <!-- Refer -->
          <el-form-item :label="i18nValues['refer']" prop="refer">
            <el-input v-model="siloTrxToEdit.refer"></el-input>
          </el-form-item>
          <!-- Carrier Company -->
          <el-form-item :label="i18nValues['carrierCompany']" prop="carrierCompany">
            <el-input v-model="siloTrxToEdit.carrierCompany"></el-input>
          </el-form-item>
          <!-- Driver -->
          <el-form-item :label="i18nValues['driver']" prop="driver">
            <el-input v-model="siloTrxToEdit.driver" disabled></el-input>
          </el-form-item>
          <!-- TruckPlate -->
          <el-form-item :label="i18nValues['truckPlate']" prop="truckPlate">
            <el-input v-model="siloTrxToEdit.truckPlate" maxlength="8" disabled></el-input>
          </el-form-item>
          <p></p>
          <p></p>
          <!-- TrailerPlate -->
          <el-form-item :label="i18nValues['trailerPlate']" prop="trailerPlate">
            <el-input v-model="siloTrxToEdit.trailerPlate" maxlength="8"></el-input>
          </el-form-item>
          <!-- TruckGrossWeight -->
          <el-form-item :label="i18nValues['truckGrossWeight']" prop="truckGrossWeight">
            <el-input
              v-model="siloTrxToEdit.truckGrossWeight"
              @keypress.native="isNumberWithDecimals($event)"
              maxlength="8"
              :disabled="siloTrxToEdit.status === 'finalized' || !isInTara" 
            ></el-input>
          </el-form-item>
          <!-- TruckNetWeight -->
          <el-form-item :label="i18nValues['truckNetWeight']" prop="truckNetWeight">
            <el-input
              v-model="siloTrxToEdit.truckNetWeight"
              @keypress.native="isNumberWithDecimals($event)"
              maxlength="8"
              @input="validateWeight('truckNetWeight')"
              :disabled="siloTrxToEdit.status === 'finalized' || !isInTara" 
            ></el-input>
          </el-form-item>
        </div>

        <div></div>

        <!-- VARIETY DATA -->
        <div class="gridTemplate-five" style="margin-top: 2px; margin-bottom: 2px">
          <p class="dialog-p-subtitle">{{ i18nValues['varietyData'] }}</p>
          <!-- Humidity -->
          <el-form-item :label="i18nValues['humidity']" prop="humidity">
            <el-input
              v-model="siloTrxToEdit.humidity"
              @keypress.native="isNumberWithDecimals($event)"
            ></el-input>
          </el-form-item>
          <!-- Temperature -->
          <el-form-item :label="i18nValues['temperature']" prop="temperature">
            <el-input
              v-model="siloTrxToEdit.temperature"
              @keypress.native="isNumberWithDecimals($event)"
            ></el-input>
          </el-form-item>
          <!-- PS1000 -->
          <el-form-item label="PS1000" prop="ps1000">
            <el-input
              v-model="siloTrxToEdit.ps1000"
              @keypress.native="isNumberWithDecimals($event)"
            ></el-input>
          </el-form-item>
          <!-- Visual Quality -->
          <el-form-item :label="i18nValues['visualQuality']" prop="visualQuality">
            <el-select
              v-model="siloTrxToEdit.visualQuality"
              :placeholder="i18nValues['visualQuality']"
            >
              <el-option
                v-for="item in VisualTypesList"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- Observations -->
          <el-form-item :label="i18nValues['observations']" prop="comment" style="width: 200px;">
            <el-input v-model="siloTrxToEdit.comment"></el-input>
          </el-form-item>
        </div>
      </el-form>
      
      <!-- SILOS SECTION -->
      <div v-if="siloTrxToEdit.product.brand && siloTrxToEdit.field.name">
        <p v-if="isInTara && siloTrxToEdit.status != 'finalized'" class="dialog-p-subtitle">
          {{ i18nValues['silos'] || 'Silos' }}
        </p>
        <div
          v-for="(silo, index) in siloTrxToEdit.relatedSilos"
          :key="index"
          class="gridTemplate silosStyle"
        >
          <el-form-item v-if="isInTara && siloTrxToEdit.status !== 'finalized'"
           :label="i18nValues['silo']" class="form-item">
            <el-select
              v-model="silo.id"
              :placeholder="i18nValues['silo']"
              filterable
              :disabled="!componentsMap.get('silo_save_trx')"
            >
              <el-option
                v-for="item in availableSilos"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disabled && item.id !== silo.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isInTara && siloTrxToEdit.status !== 'finalized'"
           :label="i18nValues['quantity'] + ' (kg)'" class="form-item">
            <el-input
              v-model="silo.quantityToSet"
              :disabled="!componentsMap.get('silo_save_trx')"
              @keypress.native="isNumber($event)"
              @input="handleInput($event, index)"
            ></el-input>
          </el-form-item>
          <div class="form-item" v-if="isInTara && siloTrxToEdit.status !== 'finalized'">
            <el-button
              v-if="siloTrxToEdit.relatedSilos.length > 1"
              class="text-danger"
              style="margin-top: 30px;"
              icon="fas fa-times"
              size="small"
              :title="i18nValues['remove']"
              @click="removeSiloSelect(silo.id)"
            ></el-button>
          </div>
        </div>
        <div class="button-style-add">
          <el-button
            v-if="componentsMap.get('silo_save_trx') && isInTara && siloTrxToEdit.status !== 'finalized'"
            @click="addSiloSelect"
            icon="fas fa-plus"
            size="small"
            class="btn-primary custom-button"
          >
            {{ i18nValues['addSilo'] }}
          </el-button>
        </div>
      </div>
      
    </el-card>

    <div>
      <div class="button-style-save">
        <el-button
          v-if="componentsMap.get('silo_save') && isInTara && siloTrxToEdit.status !== 'finalized'"
          icon="fas fa-arrow-up"
          :loading="loading"
          :disabled="loading"
          size="small"
          class="btn-primary"
          @click="saveSiloTrxInput()"
        >
          {{ i18nValues["seedIncome"] }}
        </el-button>

        <el-button
          v-if="componentsMap.get('silo_save_trx') && siloTrxToEdit.status !== 'finalized'"
          icon="fas fa-check"
          :loading="loading"
          :disabled="loading"
          size="small"
          class="btn-primary"
          @click="saveSiloTrx()"
        >
          {{ i18nValues["save"] }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
export default {
  name: "SiloMovementModal",
  props: {
    componentsMap: {},
    modalTitle: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    SilosList: {
      type: Array,
      default: () => []
    },
    siloTrx: {
      type: Object,
      default: () => ({
        id: null,
        product: {},
        field: {},
        fieldLot: {},
        relatedSilos: []
      })
    },
  },
  data() {
    return {
      siloTrxToEdit: {},
      SilosListFiltered: [],
      fetched: false,
      copy: {},
      hasSaved: false
    };
  },
  computed: {
    // Changed to use the silo module's loading state
    loading: get("silo/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
    i18nValues: get("i18nStore/valuesRetrieved"),
    VisualTypesList() {
      return [
        { id: 1, name: this.i18nValues['good'], value: "good" },
        { id: 2, name: this.i18nValues['regular'], value: "regular" },
        { id: 3, name: this.i18nValues['bad'], value: "bad" }
      ];
    },
    isInTara() {
      // operationRaw is set by FieldSection.transaleteMovements before it overwrites operation with i18n text
      const op = this.siloTrxToEdit && (this.siloTrxToEdit.operationRaw || this.siloTrxToEdit.operation);
      return op === 'inTara';
    },
    availableSilos() {
      const selectedSilos = this.siloTrxToEdit.relatedSilos || [];
      return this.SilosListFiltered.map(silo => {
        const isSelected = selectedSilos.some(selected => selected.id === silo.id);
        return {
          ...silo,
          disabled: isSelected
        };
      }).sort((a, b) => {
        const nameA = a.name ? a.name.match(/\d+/) : null;
        const nameB = b.name ? b.name.match(/\d+/) : null;
        const numA = nameA ? parseInt(nameA[0], 10) : 0;
        const numB = nameB ? parseInt(nameB[0], 10) : 0;
        if (numA !== numB) {
          return numA - numB;
        }
        return (a.name || '').localeCompare(b.name || '');
      });
    }
  },
  created() {},
  watch: {
    siloTrx: {
      handler(newVal, oldVal) {
        this.siloTrxToEdit = JSON.parse(JSON.stringify(newVal));
        // Filter out ghost entries returned by backend with all-null fields
        if (this.siloTrxToEdit.relatedSilos) {
          this.siloTrxToEdit.relatedSilos = this.siloTrxToEdit.relatedSilos.filter(s => s.id != null);
        }
        this.copy = JSON.parse(JSON.stringify(this.siloTrxToEdit));
        this.hasSaved = false;
        this.autoCalculateInput();
        if (!oldVal || newVal.id !== oldVal.id) {
          this.fetched = false;
          this.fetchAvailableSilos();
        }
      },
      immediate: true,
      deep: true
    },
    'siloTrxToEdit.truckGrossWeight'() {
      this.autoCalculateInput();
    },
    'siloTrxToEdit.truckNetWeight'() {
      this.autoCalculateInput();
    }
  },
  methods: {
    close() {
      if (!this.hasSaved) {
        this.siloTrxToEdit = JSON.parse(JSON.stringify(this.copy));
      }
      this.$emit("update:visible", false);
    },
    saveSiloTrx() {
      this.siloTrxToEdit.user = this.user.name;
      this.siloTrxToEdit.fieldSite = this.globalFieldSite;
      const gross = parseFloat(this.siloTrxToEdit.truckGrossWeight) || 0;
      const net = parseFloat(this.siloTrxToEdit.truckNetWeight) || 0;
      const expected = gross - net;
      if (this.isInTara) {
        const totalAllocated = this.siloTrxToEdit.relatedSilos.reduce((sum, silo) => {
          return sum + (parseFloat(silo.quantityToSet) || 0);
        }, 0);
        if (totalAllocated !== expected) {
          const diff = expected - totalAllocated;
          if (diff > 0) {
            this.$message.error(`${this.i18nValues["missingAmountSilo"]} ${diff} kg.`);
          } else {
            this.$message.error(`${this.i18nValues["exceedsAmountSilo"]} ${Math.abs(diff)} kg.`);
          }
          return;
        }
      }
      this.$store.dispatch("silo/saveSiloTrx", this.siloTrxToEdit)
        .then((res) => {
          if (res.status === "OK") {
            this.hasSaved = true;
            this.copy = JSON.parse(JSON.stringify(this.siloTrxToEdit));
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["SiloTrxSaved"],
              position: "bottom-right",
            });
            this.$emit("updateSilos");
            this.close();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["SiloTrxSavedError"],
              position: "bottom-right",
            });
          }
        });
    },
    saveSiloTrxInput() {
      this.siloTrxToEdit.user = this.user.name;
      this.siloTrxToEdit.fieldSite = this.globalFieldSite;
      if (this.isInTara) {
        const gross = parseFloat(this.siloTrxToEdit.truckGrossWeight) || 0;
        const net = parseFloat(this.siloTrxToEdit.truckNetWeight) || 0;
        const expected = gross - net;
        const totalAllocated = this.siloTrxToEdit.relatedSilos.reduce((sum, silo) => {
          return sum + (parseFloat(silo.quantityToSet) || 0);
        }, 0);
        if (totalAllocated !== expected) {
          const diff = expected - totalAllocated;
          if (diff > 0) {
            this.$message.error(`${this.i18nValues["missingAmountSilo"]} ${diff} kg.`);
          } else {
            this.$message.error(`${this.i18nValues["exceedsAmountSilo"]} ${Math.abs(diff)} kg.`);
          }
          return;
        }
        this.$store.dispatch("silo/saveSiloTrxInput", this.siloTrxToEdit)
          .then((res) => {
            if (res.status === "OK") {
              this.hasSaved = true;
              this.copy = JSON.parse(JSON.stringify(this.siloTrxToEdit));
              this.$notify.success({
                title: this.i18nValues["success"],
                message: this.i18nValues["SiloTrxSaved"],
                position: "bottom-right",
              });
              this.$emit("updateSilos");
              this.close();
            } else if (res.status === "EXCEED_CAPACITY") {
              this.$message.error('Silo ' + res.statusDescription + ": " + this.i18nValues["siloMaxCapacity"] );
            } else {
              this.$notify.error({
                title: this.i18nValues["error"],
                message: this.i18nValues["SiloTrxSavedError"],
                position: "bottom-right",
              });
            }
          });
      }
    },
    addSiloSelect() {
      const relatedSilos = this.siloTrxToEdit.relatedSilos;
      if (relatedSilos.length > 0) {
        const lastSilo = relatedSilos[relatedSilos.length - 1];
        if (!lastSilo.id) {
          this.$message.warning(this.i18nValues['selectSiloBeforeAdding'] || 'Please select a silo before adding a new one.');
          return;
        }
      }
      this.siloTrxToEdit.relatedSilos.push({ id: null, quantityToSet: null });
    },
    fetchAvailableSilos() {
      if (!this.fetched) {
        this.SilosListFiltered = [];
        if (!this.siloTrxToEdit.field || !this.siloTrxToEdit.product) {
          return;
        }
        this.SilosList.forEach((silo) => {
          if (silo.field && silo.product && silo.field.id === this.siloTrxToEdit.field.id && silo.product.id === this.siloTrxToEdit.product.id) {
            const siloCopy = { ...silo };
            this.SilosListFiltered.push(siloCopy);
          } else if (silo.field == null && silo.product == null && silo.pending == false && silo.type != 'discard' && silo.status !== 'inTara') {
            const siloCopy = { ...silo };
            this.SilosListFiltered.push(siloCopy);
          }
        });
        this.siloTrxToEdit.relatedSilos.forEach((relatedSilo) => {
          const alreadyExists = this.SilosListFiltered.some(
            (silo) => silo.id === relatedSilo.id
          );
          if (!alreadyExists) {
            const siloCopy = { ...relatedSilo };
            this.SilosListFiltered.push(siloCopy);
          }
        });
        this.SilosListFiltered = this.SilosListFiltered.filter((silo, index, self) => {
          return index === self.findIndex(item => item.id === silo.id);
        });
        this.fetched = true;
      }
    },
    removeSiloSelect(id) {
      this.siloTrxToEdit.relatedSilos = this.siloTrxToEdit.relatedSilos.filter(
        (silo) => silo.id !== id
      );
    },
    isNumber(evt) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    isNumberWithDecimals(evt) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 46) {
        return;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    handleInput(event, index) {
      let value = parseFloat(this.siloTrxToEdit.relatedSilos[index].quantityToSet) || 0;
      if (value < 0) {
        this.$message.error(this.i18nValues["negativeValueNotAllowedCheckWeight"]);
        this.siloTrxToEdit.relatedSilos[index].quantityToSet = 0;
      }
    },

    autoCalculateInput() {
      if (
        this.siloTrxToEdit.relatedSilos &&
        this.siloTrxToEdit.relatedSilos.length === 1 &&
        this.siloTrxToEdit.truckGrossWeight != null &&
        this.siloTrxToEdit.truckNetWeight != null
      ) {
        let calculatedValue =
          this.siloTrxToEdit.truckGrossWeight - this.siloTrxToEdit.truckNetWeight;
        this.siloTrxToEdit.relatedSilos[0].quantityToSet = calculatedValue;
      }
    },
    validateWeight(field) {
      let gross = parseFloat(this.siloTrxToEdit.truckGrossWeight) || 0;
      let net = parseFloat(this.siloTrxToEdit.truckNetWeight) || 0;
      if (field === "truckGrossWeight" && gross <= net) {
        this.$message.warning(this.i18nValues["grossWeightMustBeGreater"]);
      } else if (field === "truckNetWeight" && net >= gross) {
        this.$message.warning(this.i18nValues["grossWeightMustBeGreater"]);
        this.siloTrxToEdit.truckNetWeight = 0;
      }
    }
  }
};
</script>

<style scoped>
.custom-button {
  margin-top: 10px;
  padding: 7px 12px;
}

.silosStyle {
  margin-left: 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.button-style-add {
  margin-left: 20px;
}

.button-style-save {
  display: flex;
  justify-content: flex-end;
  margin-right: 15px;
  margin-top: 15px;
}

.custom-dialog .el-dialog__header {
  background-color: #009d57 !important;
  color: #009d57 !important;
}
</style>
